var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.259,
    height: 15.991,
    viewBox: "0 0 23.259 15.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -80)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.259,83.771V82.544A2.544,2.544,0,0,0,20.715,80H2.544A2.544,2.544,0,0,0,0,82.544v1.227A.227.227,0,0,0,.227,84h22.8A.227.227,0,0,0,23.259,83.771Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,200.227V208a2.544,2.544,0,0,0,2.544,2.544H20.715A2.544,2.544,0,0,0,23.259,208v-7.768a.227.227,0,0,0-.227-.227H.227A.227.227,0,0,0,0,200.227Zm5.815,5.951a.727.727,0,0,1-.727.727H4.361a.727.727,0,0,1-.727-.727v-.727a.727.727,0,0,1,.727-.727h.727a.727.727,0,0,1,.727.727Z",
    transform: "translate(0 -114.549)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.576b4afcbd95b089cc8bd702f66819e8.svg";
export { ForwardRef as ReactComponent };